import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 30.8574,
	height: 18.4082,
	viewBox: "0 0 30.8574 18.4082",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Mastercard",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Left",
				d: "M21.499 0C26.6673 0.00010492 30.8572 4.12111 30.8574 9.2041C30.8574 14.2873 26.6674 18.4081 21.499 18.4082C19.1816 18.4082 17.0622 17.5782 15.4277 16.2061C13.7934 17.5777 11.6753 18.4082 9.3584 18.4082C4.18994 18.4082 0 14.2873 0 9.2041C0.00018666 4.12104 4.19006 0 9.3584 0C11.6752 2.02216e-05 13.7935 0.830636 15.4277 2.20215C17.0622 0.830129 19.1818 0 21.499 0Z",
				fill: "#ED0006"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Right",
				d: "M21.4989 5.91279e-06C26.6672 3.74652e-05 30.8571 4.12107 30.8573 9.20411C30.8573 14.2873 26.6673 18.4082 21.4989 18.4082C19.1817 18.4082 17.063 17.578 15.4286 16.2061C17.4397 14.5179 18.7167 12.0084 18.7167 9.20411C18.7165 6.39984 17.4398 3.89025 15.4286 2.20215C17.0629 0.830382 19.1819 5.91279e-06 21.4989 5.91279e-06Z",
				fill: "#F9A000"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Middle",
				d: "M15.4287 2.20196C17.44 3.89013 18.7168 6.40046 18.7168 9.20489C18.7166 12.0089 17.4396 14.5178 15.4287 16.2059C13.4177 14.5178 12.1407 12.0089 12.1406 9.20489C12.1406 6.40042 13.4173 3.89013 15.4287 2.20196Z",
				fill: "#FF5E00"
			})
		]
	})
});
export default SvgMastercard;
